import settingsActionCreatorFactory from 'typescript-fsa'
import { ActionCall } from '@professocial/professocialTypes/types'

export const commonActionCreator = settingsActionCreatorFactory('SETTINGS')

/**
 * Actions
 */

export const requestStarted = commonActionCreator<ActionCall>('REQUEST_STARTED')
export const requestFinished = commonActionCreator<ActionCall>('REQUEST_FINISHED')
export const requestFailed = commonActionCreator<ActionCall>('REQUEST_FAILED')
export const clearRequests = commonActionCreator('CLEAR_REQUESTS')
